import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Title } from '@nerdwallet/react-typography';
import Link from '@nerdwallet/react-link';
import Image from '@nerdwallet/react-image';

import { stringInputSpec, titleInput } from '../../lib/editing-configs';

import styles from './story-cards.module.less';

const StoryCard = ({ title, linkUrl, previewImg }) => (
  <li className={styles['story-card__cont']}>
    {previewImg ? (
      <Link href={linkUrl} target="_blank">
        <Image
          className={styles['story-card-image__cont']}
          src={previewImg}
          objectFit="cover"
          objectPosition="center"
          alt={title}
        >
          <div className={styles['story-card-image__overlay']} />
        </Image>
      </Link>
    ) : null}
    <div className={styles['story-card-body__cont']}>
      <Link href={linkUrl} color="neutral-darkest" target="_blank">
        <Title size="small" className={styles['story-card-title']}>
          {title}
        </Title>
      </Link>
    </div>
  </li>
);

StoryCard.displayName = 'StoryCard';

StoryCard.propTypes = {
  title: PropTypes.string,
  linkUrl: PropTypes.string,
  previewImg: PropTypes.string,
};

StoryCard.defaultProps = {
  title: '',
  linkUrl: '',
  previewImg: '',
};

StoryCard.getEditingConfig = () => [
  titleInput,
  stringInputSpec('linkUrl', 'URL of story'),
  stringInputSpec('previewImg', 'Preview image URL'),
];

export default StoryCard;
